export default [
    {
        path: "/ai",
        name: "ai-dashboard",
        component: () => import("@/views/ai/Dashboard.vue"),
    },
    {
        path: "/account/info",
        name: "account-info",
        component: () => import("@/views/account/info.vue"),
    },
    {
        path: "/account/list",
        name: "account-list",
        component: () => import("@/views/account/list.vue"),
    },
    {
        path: "/account/stat",
        name: "account-stat",
        component: () => import("@/views/account/stat.vue"),
    },
    {
        path: "/account/bill",
        name: "account-bill",
        component: () => import("@/views/account/bill.vue"),
    },

    {
        path: "/ai/chat/general",
        name: "ai-chat-general",
        component: () => import("@/views/ai/chat/general.vue"),
    },
    {
        path: "/ai/chat/general/:sid",
        name: "ai-chat-general-sid",
        component: () => import("@/views/ai/chat/general.vue"),
    },
    {
        path: "/ai/chat/ai1",
        name: "ai-chat-ai1",
        component: () => import("@/views/ai/chat/chat_v1.vue"),
    },
    {
        path: "/ai/chat/ai2",
        name: "ai-chat-ai2",
        component: () => import("@/views/ai/chat/chat_v2.vue"),
    },
    {
        path: "/ai/chat/claude",
        name: "ai-chat-claude",
        component: () => import("@/views/ai/chat/claude.vue"),
    },
    {
        path: "/ai/chat/gemini",
        name: "ai-chat-gemini",
        component: () => import("@/views/ai/chat/gemini.vue"),
    },
    {
        path: "/ai/art/image",
        name: "ai-art-image",
        component: () => import("@/views/ai/art/image_v2.vue"),
    },
    {
        path: "/ai/art/image2",
        name: "ai-art-image2",
        component: () => import("@/views/ai/art/image_new.vue"),
    },
    {
        path: "/ai/art/image/history",
        name: "ai-art-image-history",
        component: () => import("@/views/ai/art/imageHistory.vue"),
    },
    {
        path: "/ai/art/image/describe",
        name: "ai-art-image-describe",
        component: () => import("@/views/ai/art/imageDescribe.vue"),
    },
    {
        path: "/ai/art/faceswap",
        name: "ai-art-faceswap",
        component: () => import("@/views/ai/art/faceswap.vue"),
    },
    {
        path: "/ai/art/image/search",
        name: "ai-art-image-search",
        component: () => import("@/views/ai/art/search.vue"),
    },
]